var __TEMP__ = require('./_Set.js');var Set = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./noop.js');var noop = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToArray.js');var setToArray = __REQUIRE_DEFAULT__(__TEMP__);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createSet;
